export default {"src":"/_next/static/media/SVGServices03.7c905203.svg","height":679,"width":796};